module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
  "use strict";

  var _ = {
    baseValidator: [
      {
        validator: "length",
        options: { min: 6 },
        message: "Password must contain at least six characters.",
      },
      {
        validator: "regexp",
        options: { regexp: /^[^\s\\\/"#][^\\\/"#]*$/ },
        message:
          'The field cannot contain spaces or special characters  / " # .',
      },
    ],
  };

  fox.registerWidget(
    "User_PasswordRecovery_Confirmation",
    {
      configure: function (options) {
        this.registerOptions("", {
          template: "user_passwordrecovery_confirmation",
          manualRender: true,
          successfulAction: false,
          widgets: {
            confirmApi: {
              widget: "Api",
              method: "passwordRecovery.changePassword",
            },
            checkHashApi: {
              widget: "Api",
              method: "passwordRecovery.validateHash",
            },
            successPopup: {
              widget: "Popup_Common",
              "widgets.content": {
                template: "popup_user_passwordChangeSuccess",
                handleDom: {
                  close: {
                    target: ".close",
                    event: "click",
                    callback: function () {
                      fox.Navigator.update({ 0: "home" }, true);
                      window.location.reload();
                    },
                  },
                },
              },
            },
          },
        });

        this.callParent("configure", arguments);
      },

      activate: function () {
        this.checkHash();
        this.callParent("activate", arguments);
      },

      checkHash: function () {
        var hash = fox.Navigator.get(1);

        this.wom1("#checkHashApi")
          .psend({ hash: hash })
          .then(
            function (resp) {
              var success = fox.objectGet(
                resp,
                "params.answer.response.success"
              );

              if (!success) {
                this.switchState("error");
                return;
              }
              this.hash = hash;
              this.switchState("form");
            }.bind(this)
          )
          .catch(
            function (resp) {
              this.switchState("error");
            }.bind(this)
          );
      },

      submit: function () {
        if (!this.callParent("submit", arguments)) {
          return false;
        }

        this._inProgress = true;
        this.toggleLoader(true);

        this.wom1("#confirmApi")
          .psend(fox.merge(this.wom1("#form").getValues(), { hash: this.hash }))
          .then(this.handleResponse.bind(this))
          .catch(this.handleError.bind(this));
      },

      compareValues: function (val) {
        var pass = this.dom1('[name="password"]').value;

        return {
          result: pass === val,
          field: "confirm",
          message: "The password do not match.",
        };
      },

      handleResponse: function (resp) {
        this.callParent("handleResponse", arguments);

        if (!this.getOption("successfulAction")) {
          this.rwom1("#successPopup").show();
        } else {
          var successPage = this.getOption("successfulAction");
          successPage(this);
        }
      },

      switchState: function (alias) {
        this.setTemplateOptions("isError", alias === "error");

        if (alias === "form") {
          this.embedWidget("form", "DomForm", {
            widget: "DomForm",
            formSelector: "#confirmation-form",
            elements: {
              password: {
                validators: _.baseValidator,
              },
              confirm: {
                validators: _.baseValidator.concat(
                  this.compareValues.bind(this)
                ),
              },
            },
            "handleWom.formValid": {
              widget: "@this",
              event: ["form_valid", "form_not_valid"],
              callback: "@parent:formInvalidate",
            },
            "handleDom.submit": {
              event: "submit",
              target: "#confirmation-form",
            },
          }).run();
        }

        this.render();
      },
    },
    "User_PasswordRecovery_Base"
  );
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/user/passwordRecovery/confirmation.js
// module id = 143
// module chunks = 4